import req from "@/utils/request";
export const columnTree = (params) => req.post("/site-service/m/site/column/newTree", params);